import { C } from '../theme';
import type { LedgerScope } from '../api';

/**
 * The period filter for a register: a light chip row of financial years (Indian
 * FY, Apr–Mar) plus "All". Mobile-friendly (chips, never a modal). Controlled —
 * the parent holds the LedgerScope and re-fetches the register on change.
 */
export function LedgerFilter({
  fyOptions,
  value,
  onChange,
}: {
  fyOptions: Array<{ fy: number; label: string }>;
  value: LedgerScope;
  onChange: (scope: LedgerScope) => void;
}) {
  const defaultFy = fyOptions[0]?.fy; // highest = current FY (the default view)
  const selectedFy = value.all ? null : value.fy ?? defaultFy;

  const chips: Array<{ key: string; label: string; active: boolean; scope: LedgerScope }> = [
    ...fyOptions.map((o) => ({
      key: `fy-${o.fy}`,
      label: o.label,
      active: !value.all && selectedFy === o.fy,
      scope: { fy: o.fy } as LedgerScope,
    })),
    { key: 'all', label: 'All', active: !!value.all, scope: { all: true } },
  ];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7 }}>
      {chips.map((ch) => (
        <button
          key={ch.key}
          onClick={() => onChange(ch.scope)}
          style={{
            border: `1px solid ${ch.active ? C.accent : C.line}`,
            background: ch.active ? C.accent : C.card,
            color: ch.active ? '#fff' : C.ink2,
            fontWeight: 600,
            fontSize: 12.3,
            padding: '6px 12px',
            borderRadius: 999,
            cursor: 'pointer',
          }}
        >
          {ch.label}
        </button>
      ))}
    </div>
  );
}
